export default __webpack_public_path__ + "static/media/Balthus's Woodland Helm.f4546109.jpg";